import React, { startTransition, useEffect, useState } from "react";
import { CardContainer } from "../../components/Card/CardContainer";
import {
  Col,
  Form,
  Row,
  Tabs,
  Image,
  Spin,
  Tag,
  Card,
  Divider,
  Steps,
  Progress,
  Table,
  ConfigProvider,
  Avatar,
  Radio,
  Flex,
  Switch,
  Collapse,
  Input,
  Space,
  Button as ButtonAntd,
  Upload,
  message,
  Checkbox,
  Modal,
  Badge,
} from "antd";
import Button from "../../components/Button/Button";
import { useNavigate } from "react-router";
import {
  EditOutlined,
  EyeOutlined,
  InfoCircleFilled,
  SearchOutlined,
  UpOutlined,
  DownOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  getFlashSaleById,
  getFlashSaleHistory,
  getFlashSaleNotification,
  getFlashSaleRound,
  getFlashSaleShopById,
  getFlashSaleShopQuotaByRound,
  getShopListByFlashSaleId,
  updateNotiCountdown,
  updateNotiPreview,
  updateNotiRound,
} from "../../datasource/FlashSaleDatasource";
import dayjs, { Dayjs } from "dayjs";
import PageTitleNested from "../../components/PageTitle/PageTitleNested";
import BreadCrumb from "../../components/BreadCrumb/BreadCrumb";
import Permission from "../../components/Permission/Permission";
import { FlexCol, FlexRow } from "../../components/Container/Container";
import Text from "../../components/Text/Text";
import { mapBgColor, mapStatus, mapTextColor } from "../../definitions/flashSaleStatus";
import { color, icon, image } from "../../resource";
import { numberFormatter } from "../../utility/Formatter";
import Select from "../../components/Select/Select";
import { getProductCategory, getProductGroup } from "../../datasource/ProductDatasource";
import { useEffectOnce } from "react-use";
import { ModalPreviewFile } from "../NewCODiscount/CODiscountComponent";
import { getZones } from "../../datasource/CustomerDatasource";
import { getShopGroup } from "../../datasource/ShopGroupDatasoure";
import { FixedType } from "rc-table/lib/interface";
import styled from "styled-components";
import TextArea from "antd/es/input/TextArea";
import { shopDatasource } from "../../datasource/ShopDatasource";
import { getCompanyList } from "../../datasource/CompanyDatasource";
import {
  convertImageFlashSale,
  createHighlightFlashSale,
  getHighlightById,
} from "../../datasource/News";
import { UploadArea, UploadIcon } from "./FlashSaleStyle";
import ImgCrop from "antd-img-crop";
import { getBase64 } from "../../utility/uploadHelper";
import { RcFile } from "antd/es/upload";
import { ImageWithDeleteButton } from "../../components/Image/Image";
import DatePicker, { TimePicker } from "../../components/DatePicker/DatePicker";
import { ReviewHighLightNews } from "../NewsPage/CreateHighLightNews";
import { useMessageContext } from "../../context/MessageProvider";
import { TrackingFlashSale } from "./TrackingFlashSale";
import NewModalInfoCredit from "../../components/Modal/NewModalInfoCredit";
import { checkDuplicateHighlight, HighLightDupList } from "./CreateFlashSale";

const StyledCollapse = styled(Collapse)`
  .ant-collapse-content-box {
    padding: 30px 20px 30px 20px !important;
  }
`;
const UploadVeritical = styled(Upload)`
  .ant-upload,
  .ant-upload-list-picture-card-container,
  .ant-upload-picture-card-wrapper,
  .ant-upload-list-picture-card .ant-upload-list-item {
    height: 160px;
    width: 120px;
  }
`;
const imgCropProps = {
  modalTitle: "ปรับขนาดรูปภาพ",
  modalOk: "ยืนยัน",
  modalCancel: "ยกเลิก",
};
export const CustomFormItem = styled(Form.Item)`
  .ant-form-item-explain-error {
    color: red;
    font-size: 13px;
    padding-top: 20px;
  }
`;

export const DetailFlashSale: React.FC = () => {
  const company = JSON.parse(localStorage.getItem("profile")!).company;
  const { pathname } = window.location;
  const pathSplit = pathname.split("/") as Array<string>;
  const id = pathSplit[3];
  const navigateType = pathSplit[4];
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [tab, setTab] = useState(navigateType);
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    await getFlashSaleById(id).then((data) => {
      form.setFieldsValue({
        flashSaleId: data?.flashSaleId,
        company: data?.company,
        flashSaleName: data?.flashSaleName,
        promotionCode: data?.promotionCode,
        fileImage: data?.coverImage,
        fileImageUrl: data?.coverImageUrl,
        productBrandId: data?.productBrandId,
        productBrandName: data?.productBrandName,
        fileMemo: data?.refFile,
        fileMemoUrl: data?.refFileUrl,
        mainStartDate: data?.startDate,
        mainEndDate: data?.endDate,
        cartLockTime: data?.cartLockTime,
        isFreeShip: data?.isFreeShip,
        prelaunchPreview: data?.prelaunchPreview,
        previewDate: data?.previewDate,
        previewTime: data?.previewDate,
        rounds: data?.rounds?.map((round: any) => ({
          ...round,
          startDate: round?.startDate,
          endDate: round?.endDate,
          startTime: round?.startDate,
          endTime: round?.endDate,
        })),
        status: data?.status,
        highLightNewsId: data?.highLightNewsId || null,
      });
    });
  };

  useEffect(() => {
    fetchData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);

  const PageTitle = () => {
    return (
      <PageTitleNested
        title=' รายละเอียด Flash Sale'
        customBreadCrumb={
          <BreadCrumb
            data={[
              {
                text: "รายการ Flash Sale",
                path: "/PromotionPage/flashSale",
              },
              {
                text: "รายละเอียด Flash Sale",
                path: window.location.pathname,
              },
            ]}
          />
        }
        onBack={() => navigate("/PromotionPage/flashSale")}
        extra={
          <>
            {(form.getFieldValue("status") === "DRAFT" ||
              form.getFieldValue("status") === "WAIT_APPROVE" ||
              form.getFieldValue("status") === "WAIT_ACTIVE") && (
              <Permission permission={["flashSale", "edit"]}>
                <Col>
                  <Button
                    typeButton='primary-light'
                    icon={<EditOutlined />}
                    title='แก้ไข'
                    height={40}
                    onClick={() =>
                      startTransition(() => {
                        navigate(`/PromotionPage/flashSale/${id}/edit`);
                      })
                    }
                  />
                </Col>
              </Permission>
            )}
          </>
        }
      />
    );
  };

  return (
    <>
      <CardContainer>
        <PageTitle />
        <Divider />
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <Spin size='large' />
          </div>
        ) : (
          <Tabs
            style={{ fontFamily: "IBM Plex Sans Thai" }}
            activeKey={tab}
            onChange={(key) => {
              setLoading(true);
              setTab(key);
              setTimeout(() => {
                setLoading(false);
              }, 500);
            }}
            items={[
              {
                label: "รายละเอียดโปรโมชัน",
                key: "detail",
                children: <DetailTab form={form} />,
              },
              {
                label: "ติดตามแคมเปญ",
                key: "tracking",
                children: (
                  <TrackingFlashSale
                    flashSaleId={id}
                    status={form?.getFieldValue("status")}
                    flashSaleName={form?.getFieldValue("flashSaleName")}
                  />
                ),
              },
              {
                label: "การแจ้งเตือน",
                key: "notification",
                children: (
                  <NotificationFlashSale
                    form={form}
                    flashSaleId={id}
                    company={form.getFieldValue("company")}
                    brandId={form.getFieldValue("productBrandId")}
                  />
                ),
              },
              {
                label: "ไฮไลท์ข่าวสาร",
                key: "highlight",
                children: (
                  <HighlightFlashSale
                    highLightNewsId={form.getFieldValue("highLightNewsId")}
                    form={form}
                    setLoading={setLoading}
                  />
                ),
              },
              {
                label: "ประวัติทำรายการ",
                key: "history",
                children: <HistoryFlashSale flashSaleId={id} />,
              },
            ]}
          />
        )}
      </CardContainer>
    </>
  );
};

const DetailTab: React.FC<{ form: any }> = ({ form }) => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const data = form.getFieldsValue(true);
  const [category, setCategory] = useState("product");
  const [openPdf, setOpenPdf] = useState(false);
  const [loading, setLoading] = useState(false);

  const into1 = [
    {
      lable: "สถานะ",
      childen: (
        <Tag style={{ backgroundColor: mapBgColor[data?.status], border: "none" }}>
          <Text color={mapTextColor[data?.status]} fontWeight={600}>
            {mapStatus[data?.status]}
          </Text>
        </Tag>
      ),
    },
    { lable: "ชื่อโปรโมชัน", childen: <Text>{data?.flashSaleName}</Text> },
    { lable: "รหัสโปรโมชัน", childen: <Text>{data?.promotionCode}</Text> },
    {
      lable: "ระยะเวลาโปรโมชัน",
      childen: data?.mainStartDate ? (
        <Text>{`${dayjs(data?.mainStartDate).format("DD/MM/YYYY")} - ${dayjs(data?.mainEndDate).format("DD/MM/YYYY")}`}</Text>
      ) : (
        <Text>-</Text>
      ),
    },
    {
      lable: "รอบการจัดแคมเปญ",
      childen:
        data?.rounds?.length < 1 ? <Text>-</Text> : <Text>{data?.rounds?.length ?? 0} รอบ</Text>,
    },
  ];
  const into2 = [
    { lable: "แบรนด์สินค้าที่ขาย", childen: <Text>{data?.productBrandName ?? "-"}</Text> },
    { lable: "เวลาล็อคตะกร้า (Cart Lock)", childen: <Text>{data?.cartLockTime ?? "-"} นาที</Text> },
    {
      lable: "สิทธิ์จัดส่งฟรี",
      childen: (
        <Text>
          {data?.isFreeShip ? "ทุกคำสั่งซื้อได้รับสิทธิ์จัดส่งฟรี" : "ไม่ได้รับสิทธิ์จัดส่งฟรี"}
        </Text>
      ),
    },
    { lable: "ตั้งค่าแจ้งเตือน", childen: <Text>-</Text> },
  ];
  const Info = () => {
    return (
      <Row justify='space-between' gutter={8}>
        <Col span={12}>
          {into1.map((item) => (
            <Row justify='space-between' key={item.lable} style={{ marginBottom: "8px" }}>
              <Col span={12}>
                <Text color='Text3'>{item.lable}</Text>
              </Col>
              <Col span={12}>{item.childen}</Col>
            </Row>
          ))}
        </Col>
        <Col span={12}>
          {into2.map((item) => (
            <Row justify='space-between' key={item.lable} style={{ marginBottom: "8px" }}>
              <Col span={12}>
                <Text color='Text3'>{item.lable}</Text>
              </Col>
              <Col span={12}>{item.childen}</Col>
            </Row>
          ))}
        </Col>
      </Row>
    );
  };

  return (
    <>
      <Row>
        <Image
          width={160}
          alt='basic'
          src={form.getFieldValue("fileImageUrl")}
          style={{ borderRadius: "8px" }}
        />
      </Row>
      <br />
      <Info />
      <br />
      <Text fontWeight={600}>เอกสารอ้างอิง</Text>
      <Col span={12}>
        <Card bodyStyle={{ padding: 12, backgroundColor: "#F3F6F9" }}>
          <Row justify='space-between' style={{ alignItems: "center" }}>
            <Col>
              <img src={icon.icon_pdf} alt='PDF Icon' style={{ width: "22px", height: "26px" }} />
              &nbsp;&nbsp;&nbsp;
              {data.fileMemoUrl?.length ? (
                <Text level={6}>
                  {data.fileMemoUrl?.length > 50
                    ? `${data.fileMemoUrl.substring(0, 50)}...pdf`
                    : data.fileMemoUrl}
                </Text>
              ) : (
                <Text color='Text3' level={6}>
                  ไม่มีไฟล์แนบ
                </Text>
              )}
            </Col>
            <Col>
              <Button
                typeButton={data.fileMemoUrl ? "primary" : "disabled"}
                icon={<EyeOutlined style={{ color: color.white }} />}
                title='ดูรายละเอียด'
                height={40}
                onClick={() => data.fileMemoUrl && setOpenPdf(true)}
              />
            </Col>
          </Row>
        </Card>
      </Col>
      <Divider />
      <Text fontWeight={600} level={4}>
        รายละเอียด
      </Text>
      <Row justify='start' gutter={16} style={{ marginTop: "16px" }}>
        <Col span={3}>
          <Button
            typeButton={category === "product" ? "active-secondary" : "inactive-secondary"}
            textStyle={{ color: category === "product" ? "white" : "secondary" }}
            title={"สินค้าแต่ละรอบ"}
            height={40}
            onClick={() => {
              setLoading(true);
              setCategory("product");
              setTimeout(() => {
                setLoading(false);
              }, 300);
            }}
          />
        </Col>
        <Col span={3}>
          <Button
            typeButton={category === "shop" ? "active-secondary" : "inactive-secondary"}
            textStyle={{ color: category === "shop" ? "white" : "secondary" }}
            title={"ร้านค้าที่เข้าร่วม"}
            height={40}
            onClick={() => {
              setLoading(true);
              setCategory("shop");
              setTimeout(() => {
                setLoading(false);
              }, 300);
            }}
          />
        </Col>
      </Row>
      <br />
      {openPdf && (
        <ModalPreviewFile
          openPdf={openPdf}
          setOpenPdf={setOpenPdf}
          fileRef={form.getFieldValue("fileMemoUrl")}
        />
      )}
      <>
        {loading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "40vh",
            }}
          >
            <Spin size='large' />
          </div>
        ) : (
          <>
            {category === "product" && (
              <>
                {form?.getFieldValue("rounds")?.length === 0 ? (
                  <div
                    style={{
                      padding: 32,
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 24,
                      minHeight: 350,
                    }}
                  >
                    <img
                      src={icon.emptyHistoryPoint}
                      style={{
                        width: 80,
                        height: 90,
                      }}
                      alt='empty_table'
                    />
                    <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                      ยังไม่มีรอบขาย
                    </Text>
                  </div>
                ) : (
                  <SlotProductDetail
                    rounds={form?.getFieldValue("rounds")}
                    isSearch={true}
                    company={profile.company}
                    dataForm={form.getFieldsValue(true)}
                  />
                )}
              </>
            )}
            {category === "shop" && (
              <ShopDetail
                flashSaleId={form?.getFieldValue("flashSaleId")}
                isCredit={false}
                company={profile.company}
                isSearch={true}
              />
            )}
          </>
        )}
      </>
    </>
  );
};

export const SlotProductDetail: React.FC<{
  rounds: any;
  isSearch: boolean;
  company: string;
  dataForm: any;
}> = ({ rounds, isSearch, company, dataForm }) => {
  const [current, setCurrent] = useState(0);
  const [selectedRound, setSelectedRound] = useState(rounds?.[0]?.flashSaleRoundId);
  const [dataRound, setDataRound] = useState<any>();
  const [page, setPage] = useState(1);
  const pageSize = 6;
  const [strategyGroupList, setStrategyGroupList] = useState<any[]>([]);
  const [prodGroupList, setProdGroupList] = useState<any[]>([]);
  const [expandedRowKeys, setExpandedRowKeys] = useState<React.Key[]>([]);

  const [searchText, setSearchText] = useState(undefined);
  const [keyWord, setKeyWord] = useState(undefined);
  const [searchProdGroup, setSearchProdGroup] = useState(undefined);
  const [searchStrategy, setSearchStrategy] = useState(undefined);

  const optionPrice = [
    { name: "แสดงราคาเต็ม", key: "FULL", value: "10,008.00฿", img: image.empty_sack },
    { name: "ไม่แสดงราคา", key: "HIDE_ALL", value: "XX,XXX.XX฿", img: image.empty_sack },
    { name: "แสดงราคาบางส่วน", key: "PARTIAL", value: "1X,XX8.XX฿", img: image.empty_sack },
    {
      name: "สินค้าเซอร์ไพรส์",
      key: "SURPRISE",
      value: "",
      img: image.red_curtain,
    },
  ];

  const fetchSelectedRound = async () => {
    await getFlashSaleRound({
      flashSaleId: selectedRound,
      search: searchText,
      productGroup: searchProdGroup,
      productStrategy: searchStrategy,
      page: page,
      take: pageSize,
    }).then((res) => {
      const map = res?.data?.map((item: any) => ({
        ...item,
        rowKey: `${item.flashSaleRoundId}-${item.productId}`,
      }));
      setDataRound({ ...res, data: map });
    });
  };

  useEffect(() => {
    fetchSelectedRound();
  }, [selectedRound, searchText, searchProdGroup, searchStrategy, page]);

  const fetchCatetory = async () => {
    await getProductCategory(company).then((res) => {
      setStrategyGroupList(res);
    });
  };
  const fetchProdGroup = async () => {
    await getProductGroup(company).then((res) => {
      setProdGroupList(res.responseData);
    });
  };

  useEffectOnce(() => {
    fetchCatetory();
    fetchProdGroup();
  });

  const TimeSlot = ({ round, startDate, endDate, time }: any) => (
    <FlexCol style={{ alignItems: "center", position: "relative" }} key={round}>
      {/* <div
        style={{
          position: "absolute",
          top: -6,
          left: "80%",
          transform: "translateX(-50%)",
        }}
      >
        <Badge
          color={color.error}
          styles={{
            indicator: {
              width: 8,
              height: 8,
              minWidth: 8,
              borderRadius: "50%",
            },
          }}
        />
      </div> */}
      <Text fontWeight={600} color={round === current + 1 ? "primary" : "Text3"}>
        รอบที่ {round}
      </Text>
      <Text level={6} color={round === current + 1 ? "primary" : "Text3"}>
        {startDate} → {endDate}
      </Text>
      <Text level={6} color={round === current + 1 ? "primary" : "Text3"}>
        ({time})
      </Text>
    </FlexCol>
  );

  const items = rounds?.map((i: any) => ({
    title: (
      <TimeSlot
        key={i.roundNo}
        round={i.roundNo}
        startDate={dayjs(i.startDate).format("DD/MM/YYYY")}
        endDate={dayjs(i.endDate).format("DD/MM/YYYY")}
        time={`${dayjs(i.startDate).format("HH:mm")}-${dayjs(i.endDate).format("HH:mm")}`}
      />
    ),
  }));

  const onSearch = (text: any, productGroup: any, strategy: any) => {
    setSearchText(text);
    setSearchProdGroup(productGroup);
    setSearchStrategy(strategy);
  };

  const columns = [
    {
      title: <span>ชื่อสินค้า</span>,
      dataIndex: "productName",
      width: "30%",
      fixed: "left" as FixedType | undefined,
      render: (text: string, value: any, index: any) => (
        <FlexRow align='center'>
          <div style={{ marginRight: 16 }}>
            <Avatar
              src={
                value.productImage === "No" ||
                value.productImage === "" ||
                value.productImage === null
                  ? image.product_no_image
                  : value.productImage
              }
              size={50}
              shape='square'
              onError={() => false}
            />
          </div>
          <FlexCol>
            <div style={{ height: 25, textOverflow: "ellipsis" }}>
              <Text level={5}>{value.productName}</Text>
            </div>
            {value.commonName && (
              <div style={{ height: 25, textOverflow: "ellipsis" }}>
                <Text level={6} style={{ color: color.Grey }}>
                  {value.commonName}
                </Text>
              </div>
            )}
            <div style={{ height: 25 }}>
              <Text level={6} style={{ color: color.Grey }}>
                Product Group : {value.productGroup}
              </Text>
            </div>
            {value.productStrategy && (
              <div style={{ height: 25 }}>
                <Text level={6} style={{ color: color.Grey }}>
                  Strategy Group : {value.productStrategy}
                </Text>
              </div>
            )}
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>ขนาด</span>,
      dataIndex: "productCode",
      width: "15%",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <div style={{ height: 25 }}>
              <Text level={5}>{text}</Text>
            </div>
            <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text level={6} style={{ color: color.Grey }}>
                Pack Size : {value.packSize}
              </Text>
            </div>
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>ราคาขาย</span>,
      dataIndex: "unitPrice",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <div style={{ height: 25, overflow: "hidden", textOverflow: "ellipsis" }}>
              <Text level={5}>
                {numberFormatter(value?.marketPrice)} บาท/{value?.saleUomTh}
              </Text>
            </div>
            {company === "ICPL" && (
              <div style={{ height: 25 }}>
                <Text level={6} style={{ color: color.Grey }}>
                  ราคา/หน่วย : {numberFormatter(text)} บาท/{value?.baseUomTh || value?.saleUomTh}
                </Text>
              </div>
            )}
          </FlexCol>
        </FlexRow>
      ),
    },
    {
      title: <span>โปรโมชัน</span>,
      dataIndex: "promotion",
      render: (text: string, value: any) => (
        <>
          {value?.promotionType !== "NONE" && value?.promotionType !== undefined ? (
            <FlexCol>
              <Text>ส่วนลด</Text>
              <Text>
                {value?.promotionType?.includes("BAHT")
                  ? `${numberFormatter(value?.discount, 2)} บาท`
                  : `${value?.discount}%`}{" "}
                / {value.saleUomTh}
              </Text>
              <Text color='success'>
                {value?.promotionType.includes("BAHT")
                  ? numberFormatter(value?.marketPrice - value?.discount, 2) + " บาท"
                  : `${numberFormatter(value?.marketPrice - value?.marketPrice * (value?.discount / 100), 2)} บาท`}
                / {value?.saleUomTh}
              </Text>
            </FlexCol>
          ) : (
            <Text>-</Text>
          )}
        </>
      ),
    },
    {
      title: <span>โควตา</span>,
      dataIndex: "quota",
      render: (text: string, value: any) => {
        return (
          <>
            {value?.quotaType === "QUOTA_TOTAL" ? (
              <FlexCol>
                <Text>โควตารวม</Text>
                <Text>
                  {numberFormatter(value?.quotaTotal, 0)} {value?.saleUomTh}
                </Text>
              </FlexCol>
            ) : value?.quotaType === "QUOTA_INDIVIDUAL" ? (
              <FlexCol>
                <Text>โควตารายร้าน</Text>
                <Text color='Text3' level={6}>
                  {(() => {
                    const isSame = value.isSameQuotaForAllShops;
                    return isSame !== null
                      ? isSame
                        ? `${numberFormatter(value?.defaultQuotaPerShop, 0)} ${value?.saleUomTh} (เท่ากันทุกร้าน)`
                        : "แต่ละร้านไม่เท่ากัน"
                      : "-";
                  })()}
                </Text>
              </FlexCol>
            ) : (
              <FlexCol>
                <Text>-</Text>
              </FlexCol>
            )}
          </>
        );
      },
    },
    {
      title: <span>แสดงราคา,สินค้า</span>,
      dataIndex: "displayPriceProduct",
      render: (text: string, value: any) => (
        <FlexRow>
          <FlexCol>
            <Text>{optionPrice?.find((option) => option.key === value.priceDisplay)?.name}</Text>
            <Text level={6} color='Text3'>
              {optionPrice?.find((option) => option.key === value.priceDisplay)?.value}
            </Text>
          </FlexCol>
        </FlexRow>
      ),
    },
  ];

  return (
    <>
      <Steps
        className='custom-navigation-steps'
        type='navigation'
        current={current}
        onChange={(step) => {
          setPage(1);
          setSearchText(undefined);
          setKeyWord(undefined);
          setSearchProdGroup(undefined);
          setSearchStrategy(undefined);
          setExpandedRowKeys([]);
          setSelectedRound(rounds?.[step]?.flashSaleRoundId);
          setCurrent(step);
        }}
        items={items}
      />
      <br />
      {isSearch && (
        <>
          <Row gutter={16}>
            <Col span={9}>
              <Input
                value={keyWord}
                allowClear
                placeholder='ค้นหาชื่อสินค้าหรือรหัสสินค้า...'
                suffix={<SearchOutlined />}
                style={{ width: "100%", height: 40 }}
                onChange={(e: any) => {
                  setKeyWord(e.target.value);
                  !e.target.value && (setSearchText(undefined), setKeyWord(undefined));
                }}
                onPressEnter={(e: any) => {
                  setPage(1);
                  onSearch(e.target.value, searchProdGroup, searchStrategy);
                }}
              />
            </Col>
            {company === "ICPL" && (
              <>
                <Col span={4}>
                  <Select
                    data={[
                      {
                        key: "",
                        value: "",
                        label: "ทั้งหมด",
                      },
                      ...prodGroupList.map((p: any) => ({
                        key: p.product_group,
                        value: p.product_group,
                        label: p.product_group,
                      })),
                    ]}
                    onChange={(e) => {
                      setPage(1);
                      onSearch(searchText, e, searchStrategy);
                    }}
                    placeholder='Product Group'
                    style={{ width: "100%" }}
                    value={searchProdGroup}
                  />
                </Col>
              </>
            )}
            <Col span={4}>
              <Select
                data={[
                  {
                    key: "",
                    value: "",
                    label: "ทั้งหมด",
                  },
                  ...strategyGroupList.map((p: any) => ({
                    key: p.productCategoryName,
                    value: p.productCategoryName,
                    label: p.productCategoryName,
                  })),
                ]}
                onChange={(e) => {
                  setPage(1);
                  onSearch(searchText, searchProdGroup, e);
                }}
                placeholder={company === "ICPL" ? "Strategy Group" : "Category Group"}
                style={{ width: "100%" }}
                value={searchStrategy}
              />
            </Col>
            <Col span={3}>
              <Button
                title='ล้างการค้นหา'
                typeButton='primary-light'
                onClick={() => {
                  setKeyWord(undefined);
                  setSearchText(undefined);
                  setSearchProdGroup(undefined);
                  setSearchStrategy(undefined);
                }}
              />
            </Col>
          </Row>
          <br />
        </>
      )}
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              headerColor: "black",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
              rowExpandedBg: "#FFFFFF",
              //rowHoverBg: "none",
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={dataRound?.data || []}
          rowKey='rowKey'
          scroll={{ x: 1600 }}
          tableLayout='fixed'
          pagination={{
            showSizeChanger: false,
            current: page,
            pageSize: pageSize,
            total: dataRound?.count || 0,
            position: ["bottomCenter"],
            onChange: (page, pageSize) => {
              setPage(page);
              onSearch(searchText, searchProdGroup, searchStrategy);
            },
          }}
          expandable={{
            expandedRowKeys,
            onExpandedRowsChange: (keys: any) => {
              setExpandedRowKeys(keys.length > 0 ? [keys[keys.length - 1]] : []);
            },
            expandedRowRender: (record: any) => {
              return (
                <ExpandConditionProduct
                  record={record}
                  optionPrice={optionPrice}
                  rowKey={expandedRowKeys[0]}
                />
              );
            },
            expandIcon: ({
              expanded,
              onExpand,
              record,
            }: {
              expanded: boolean;
              onExpand: any;
              record: any;
            }) => {
              return expanded ? (
                <UpOutlined onClick={(event) => onExpand(record, event)} />
              ) : (
                <DownOutlined onClick={(event) => onExpand(record, event)} />
              );
            },
          }}
          locale={{
            emptyText: (
              <div
                style={{
                  padding: 32,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 24,
                  minHeight: 350,
                }}
              >
                <img
                  src={icon.emptyHistoryPoint}
                  style={{
                    width: 80,
                    height: 90,
                  }}
                  alt='empty_table'
                />
                <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                  ยังไม่มีรายการ
                </Text>
              </div>
            ),
          }}
        />
      </ConfigProvider>
    </>
  );
};

const ExpandConditionProduct: React.FC<{ record: any; optionPrice?: any; rowKey: any }> = ({
  record,
  optionPrice,
  rowKey,
}) => {
  const [tab, setTab] = useState("PROMOTION");
  const [data, setData] = useState<any>();
  const [loading, setLoading] = useState(false);

  const fetchData = async () => {
    const quota = await getFlashSaleShopQuotaByRound(record.flashSaleRoundProductId);
    return {
      ...record,
      discount: record.discount === 0 ? undefined : record.discount,
      productCodeNAV: record.productCode,
      saleUOM: record.saleUOM || record.saleUom,
      saleUOMTH: record.saleUOMTH || record.saleUomTh,
      baseUOM: record.baseUOM || record.baseUom,
      shopQuotas: quota?.shopQuotas?.length > 0 ? quota.shopQuotas : [],
      isNonQuota: record.nonQuota || false,
    };
  };

  useEffect(() => {
    setLoading(true);
    fetchData().then((data) => {
      setData(data);
    });
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [rowKey]);

  return (
    <>
      {loading ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
          }}
        >
          <Spin size='large' />
        </div>
      ) : (
        <Tabs
          activeKey={tab}
          onChange={(key) => {
            setTab(key);
          }}
          items={[
            {
              label: <Text level={6}>โปรโมชัน</Text>,
              key: "PROMOTION",
              children: (
                <>
                  <Radio.Group
                    className='mode-radio-group'
                    value={data?.promotionType !== "NONE" ? "true" : "false"}
                    disabled
                  >
                    <Radio value='true'>
                      <Flex vertical>
                        <Text fontWeight={600} level={6}>
                          กำหนดโปรโมชันสินค้า
                        </Text>
                      </Flex>
                    </Radio>
                    <Radio value='false'>
                      <Flex vertical>
                        <Text fontWeight={600} level={6}>
                          ไม่กำหนดโปรโมชันสินค้า
                        </Text>
                      </Flex>
                    </Radio>
                  </Radio.Group>
                  {data?.promotionType !== "NONE" && (
                    <>
                      <Divider size='small' />
                      <Row>
                        <Col span={12}>
                          <Form.Item label='ประเภทโปรโมชัน'>
                            <Input
                              value={
                                data?.promotionType === "BAHT_PER_UNIT"
                                  ? "ส่วนลด บาท / หน่วย"
                                  : "ส่วนลด % / หน่วย"
                              }
                              style={{ height: "40px", color: color.BK }}
                              disabled
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row justify='start' gutter={16}>
                        <Col span={8}>
                          <Form.Item label='ราคาที่ต้องการลด'>
                            <Input
                              value={data?.discount}
                              suffix={data?.promotionType === "BAHT_PER_UNIT" ? "บาท" : "%"}
                              style={{ height: "40px", color: color.BK }}
                              disabled
                            />
                          </Form.Item>
                        </Col>
                        <Col span={4}>
                          <Form.Item label='ต่อหน่วย SKU'>
                            <Input
                              value={data?.saleUomTh}
                              style={{ height: "40px", color: color.BK }}
                              disabled
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  )}
                </>
              ),
            },
            {
              label: <Text level={6}>โควตา</Text>,
              key: "QUOTA",
              children: (
                <>
                  <Radio.Group className='mode-radio-group' value={data?.quotaType} disabled>
                    <Radio value='QUOTA_TOTAL'>
                      <Flex vertical>
                        <Text fontWeight={600} level={6}>
                          โควตารวม
                        </Text>
                      </Flex>
                    </Radio>
                    <Radio value='QUOTA_INDIVIDUAL'>
                      <Flex vertical>
                        <Text fontWeight={600} level={6}>
                          โควตารายร้าน
                        </Text>
                      </Flex>
                    </Radio>
                    <Radio value='QUOTA_NONE'>
                      <Flex vertical>
                        <Text fontWeight={600} level={6}>
                          ไม่กำหนดโควตา
                        </Text>
                      </Flex>
                    </Radio>
                  </Radio.Group>
                  {data?.quotaType == "QUOTA_TOTAL" ? (
                    <>
                      <Divider size='small' />
                      <Row>
                        <Col span={12}>
                          <Form.Item label='จำนวนโควตารวม'>
                            <Input
                              value={data?.quotaTotal}
                              style={{ height: "40px", color: color.BK }}
                              suffix={data?.saleUomTh}
                              disabled
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    </>
                  ) : data?.quotaType == "QUOTA_INDIVIDUAL" ? (
                    <>
                      <Divider size='small' />
                      <ConfigProvider
                        theme={{
                          components: {
                            Table: {
                              headerBg: "#1B4586",
                              headerColor: "#FFFFFF",
                              fontFamily: "IBM Plex Sans Thai",
                              fontSize: 15,
                            },
                          },
                        }}
                      >
                        <Table
                          size='small'
                          columns={[
                            {
                              title: "ชื่อร้านค้า",
                              dataIndex: "customerName",
                              key: "customerName",
                              width: "80%",
                              render: (value: any, row: any, index: number) => {
                                return {
                                  children: (
                                    <FlexCol>
                                      <Text>{value}</Text>
                                      <Text color='Text3'>
                                        {row.customerNo} • เขต {row.zone} • กลุ่ม{" "}
                                        {row.customerGroupName || "-"}
                                      </Text>
                                    </FlexCol>
                                  ),
                                };
                              },
                            },
                            {
                              title: "จำนวนโควตา",
                              dataIndex: "quota",
                              key: "quota",
                              render: (value: any, row: any, index: number) => {
                                return {
                                  children: (
                                    <Input
                                      value={value}
                                      style={{ height: "40px", color: color.BK }}
                                      suffix={data?.saleUomTh || ""}
                                      autoComplete='off'
                                      placeholder='กรุณาระบุจำนวนโควตา'
                                      disabled
                                    />
                                  ),
                                };
                              },
                            },
                          ]}
                          dataSource={data?.shopQuotas || []}
                          pagination={false}
                          scroll={{
                            y: 300,
                          }}
                        />
                      </ConfigProvider>
                    </>
                  ) : null}
                </>
              ),
            },
            {
              label: <Text level={6}>แสดงราคาและสินค้า</Text>,
              key: "PRICE",
              children: (
                <Row justify={"space-between"} gutter={16}>
                  <Col span={18}>
                    <Radio.Group
                      className='mode-radio-group'
                      value={data?.priceDisplay}
                      style={{
                        marginBottom: "16px",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "12px 16px",
                      }}
                      disabled
                    >
                      {optionPrice?.map((option) => (
                        <Radio value={option?.key} key={option?.key}>
                          <Flex vertical>
                            <Text fontWeight={600} level={6}>
                              {option?.name}
                            </Text>
                          </Flex>
                        </Radio>
                      ))}
                    </Radio.Group>
                  </Col>
                  <Col span={6}>
                    <div
                      style={{
                        borderRadius: "8px",
                        backgroundColor: "#EFF2F9",
                        padding: "16px",
                      }}
                    >
                      <Text fontWeight={600}>ตัวอย่างการแสดงผล</Text>
                      <Card style={{ borderRadius: "20px" }} bodyStyle={{ padding: "10px" }}>
                        <img
                          src={
                            optionPrice?.find((option) => option.key === data?.priceDisplay)?.img
                          }
                          alt='empty sack'
                          style={{ width: "100%" }}
                        />
                        {data?.priceDisplay !== "SURPRISE" ? (
                          <>
                            <div style={{ marginTop: "8px", marginBottom: "8px" }}>
                              <Text fontWeight={600} level={4}>
                                สินค้า
                              </Text>
                            </div>
                            <Row
                              justify={"start"}
                              style={{ marginTop: "8px", marginBottom: "8px" }}
                            >
                              <Col>
                                <img
                                  src={image.shipfree_tag}
                                  alt='shipfree tag'
                                  style={{ height: "25px" }}
                                />
                              </Col>
                              <Col>
                                <img
                                  src={image.discount_tag}
                                  alt='discount tag'
                                  style={{ height: "25px" }}
                                />
                              </Col>
                            </Row>
                            <Text fontWeight={600} level={4}>
                              {
                                optionPrice?.find((option) => option.key === data?.priceDisplay)
                                  ?.value
                              }{" "}
                              <Text color='Text3'>/หน่วย</Text>
                            </Text>
                            <br />
                            <Text delete color='Text3'>
                              11,200฿
                            </Text>
                          </>
                        ) : (
                          <div style={{ alignItems: "center", textAlign: "center" }}>
                            <Text fontWeight={600} level={4}>
                              สินค้าเซอร์ไพรส์
                            </Text>
                            <br />
                            <Text color='Text3'>รอเปิดตัว</Text>
                          </div>
                        )}
                      </Card>
                    </div>
                  </Col>
                </Row>
              ),
            },
          ]}
        />
      )}
    </>
  );
};

export const ShopDetail: React.FC<{
  flashSaleId: string;
  isCredit: boolean;
  company: string;
  isSearch?: boolean;
}> = ({ flashSaleId, isCredit, company, isSearch }) => {
  const [shopData, setShopData] = useState<any>();
  const [page, setPage] = useState(1);
  const pageSize = 10;
  const [zoneList, setZoneList] = useState<any[]>([]);
  const [shopGroup, setShopGroup] = useState({ count: 0, data: [] });
  const [sectionSearch, setSectionSearch] = useState<{
    searchZone: string | undefined;
    searchShopGroup: string | undefined;
    searchKeyWord: string | undefined;
  }>({
    searchZone: undefined,
    searchShopGroup: undefined,
    searchKeyWord: undefined,
  });
  const [infoCreditModal, setInfoCreditModal] = useState<{
    open: boolean;
    cusComId: any;
  }>({ open: false, cusComId: null });

  const fetchZone = async () => {
    const getZone = await getZones(company);
    setZoneList(getZone);
  };
  const fetchShopGroupList = async () => {
    await getShopGroup({
      company,
      take: 0,
      page: 0,
    }).then((res) => {
      setShopGroup({ count: res.responseData.count, data: res.responseData.data });
    });
  };

  useEffectOnce(() => {
    fetchZone();
    fetchShopGroupList();
  });

  const fetchDataShop = async () => {
    await getFlashSaleShopById({
      flashSaleId: flashSaleId,
      page,
      take: pageSize,
      search: sectionSearch.searchKeyWord,
      zone: sectionSearch.searchZone,
      customerGroupId: sectionSearch.searchShopGroup,
    }).then((data) => {
      setShopData(data);
    });
  };

  useEffect(() => {
    fetchDataShop();
  }, [page, sectionSearch]);

  const columns = [
    {
      title: "ชื่อร้านค้า",
      dataIndex: "customerName",
      key: "customerName",
      width: "20%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
              <Text color='Text3' level={6}>
                {row.customerNo} • เขต {row.zone} • กลุ่ม {row.customerGroupName || "-"}
              </Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ประเภทชำระเงิน",
      dataIndex: "termPayment",
      key: "termPayment",
      width: "10%",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value === "COD" ? "เงินสด" : "เครดิต"}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "วงเงินคงเหลือ (฿)",
      dataIndex: "termPayment",
      key: "termPayment",
      width: "15%",
      hidden: !isCredit,
      render: (value: any, row: any, index: number) => {
        return (
          <>
            {row.termPayment !== "COD" ? (
              <>
                <Progress
                  strokeColor={color.primary}
                  percent={row.percentCreditBalance}
                  showInfo={false}
                />
                <Row justify='space-between'>
                  <Col>
                    <Text color={row.creditAvailable < 0 ? "error" : "BK"} fontWeight={600}>
                      {numberFormatter(row.creditAvailable, 2)}
                    </Text>{" "}
                    <Text level={6} color={row.isOverCredit ? "error" : "Text3"}>
                      ({numberFormatter(row.percentCreditBalance, 2)}%)
                    </Text>
                    <br />
                  </Col>
                  <Col>
                    <Text>/{numberFormatter(row.creditLimit, 2)}</Text>
                    <InfoCircleFilled
                      style={{ marginLeft: 4, cursor: "pointer" }}
                      onClick={() => {
                        setInfoCreditModal({ open: true, cusComId: row.customerCompanyId });
                      }}
                    />
                  </Col>
                </Row>
              </>
            ) : (
              <Text>-</Text>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      {isSearch && (
        <Row justify={"start"} gutter={8} style={{ paddingBottom: "16px" }}>
          <Col span={8}>
            <Input
              placeholder='ค้นหาชื่อร้านค้า'
              style={{ width: "100%", height: "40px" }}
              suffix={<SearchOutlined />}
              allowClear
              onPressEnter={(e: any) => {
                setPage(1);
                setSectionSearch({
                  searchZone: sectionSearch.searchZone,
                  searchShopGroup: sectionSearch.searchShopGroup,
                  searchKeyWord: e.target.value,
                });
              }}
              onChange={(e: any) => {
                if (!e.target.value) {
                  setSectionSearch({
                    searchZone: sectionSearch.searchZone,
                    searchShopGroup: sectionSearch.searchShopGroup,
                    searchKeyWord: undefined,
                  });
                }
              }}
            />
          </Col>
          <Col span={3}>
            <Select
              value={sectionSearch.searchZone}
              data={
                zoneList?.map((zone) => ({
                  label: zone.zoneName,
                  value: zone.zoneName,
                  key: zone.zoneName,
                })) || []
              }
              placeholder='เลือกเขต'
              style={{ width: "100%" }}
              onChange={(e) => {
                setPage(1);
                setSectionSearch({
                  searchZone: e,
                  searchShopGroup: sectionSearch.searchShopGroup,
                  searchKeyWord: sectionSearch.searchKeyWord,
                });
              }}
            />
          </Col>
          <Col span={4}>
            <Select
              value={sectionSearch.searchShopGroup}
              data={
                shopGroup?.data?.map((group: any) => ({
                  label: group.customerGroupName,
                  value: group.customerGroupId,
                  key: group.customerGroupId,
                })) || []
              }
              placeholder='กลุ่มร้านค้า'
              style={{ width: "100%" }}
              onChange={(e) => {
                setPage(1);
                setSectionSearch({
                  searchZone: sectionSearch.searchZone,
                  searchShopGroup: e,
                  searchKeyWord: sectionSearch.searchKeyWord,
                });
              }}
            />
          </Col>
          <Col span={3}>
            <Button
              typeButton='primary-light'
              title='ล้างการค้นหา'
              onClick={() => {
                setPage(1);
                setSectionSearch({
                  searchZone: undefined,
                  searchShopGroup: undefined,
                  searchKeyWord: undefined,
                });
              }}
            />
          </Col>
          <Col flex='1' style={{ paddingTop: "8px", textAlign: "right" }}>
            <Text>จำนวน {shopData?.count || 0} ร้าน</Text>
          </Col>
        </Row>
      )}
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              headerColor: "black",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
              //rowHoverBg: "none",
            },
          },
        }}
      >
        <Table
          size='small'
          columns={columns}
          dataSource={shopData?.data || []}
          rowKey='customerCompanyId'
          tableLayout='fixed'
          pagination={{
            showSizeChanger: false,
            current: page,
            pageSize: pageSize,
            total: shopData?.count || 0,
            position: ["bottomCenter"],
            onChange: (page, pageSize) => {
              setPage(page);
            },
          }}
          locale={{
            emptyText: (
              <div
                style={{
                  padding: 32,
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: 24,
                  minHeight: 350,
                }}
              >
                <img
                  src={icon.emptyHistoryPoint}
                  style={{
                    width: 80,
                    height: 90,
                  }}
                  alt='empty_table'
                />
                <Text fontFamily='Sarabun' fontSize={14} fontWeight={400} color='Text3'>
                  ยังไม่มีรายการ
                </Text>
              </div>
            ),
          }}
        />
      </ConfigProvider>
      {infoCreditModal.open && (
        <NewModalInfoCredit
          open={infoCreditModal.open}
          onClose={() => setInfoCreditModal({ open: false, cusComId: null })}
          cusComId={infoCreditModal.cusComId}
        />
      )}
    </>
  );
};

const NotificationFlashSale = ({
  flashSaleId,
  company,
  brandId,
  form,
}: {
  flashSaleId: string;
  company: string;
  brandId: number;
  form: any;
}) => {
  console.log("brandId", brandId);
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const dateToday = dayjs().locale("th").toISOString();
  const [formNoti] = Form.useForm();
  const { messageApi } = useMessageContext();
  const [currentRound, setCurrentRound] = useState<number>(0);
  const [notiInfo, setNotiInfo] = useState<any>();
  const previewTitle = Form.useWatch(["preview", "title"], formNoti);
  const previewDetail = Form.useWatch(["preview", "detail"], formNoti);
  const countdownTitle = Form.useWatch(["countdown", "title"], formNoti);
  const countdownType = Form.useWatch(["countdown", "countDownType"], formNoti);
  const countdownDetail = Form.useWatch(["countdown", "detail"], formNoti);
  const watchRounds = Form.useWatch(["roundNoti", "rounds", currentRound], formNoti);
  const roundNotiIsActive = Form.useWatch(["roundNoti", "isActive"], formNoti);
  const previewIsActive = Form.useWatch(["preview", "isActive"], formNoti);
  const countdownIsActive = Form.useWatch(["countdown", "isActive"], formNoti);

  const [prodBrandData, setProdBrandData] = useState<any>();
  const [companyList, setCompanyList] = useState<any[]>([]);

  const mapCompanyName = {
    ICPL: "ไอ ซี พี ลัดดา",
    ICPI: "ไอ ซี พี อินเตอร์เนชั่นแนล",
    ICPF: "ไอ ซี พี เฟอทิไลเซอร์",
  };
  const mapCountdown = {
    MIN_15: "15:00",
    MIN_30: "30:00",
    MIN_60: "60:00",
  };

  const defaultNotiInfo = (type: "preview" | "countdown" | "roundNoti", round?: number) => {
    if (type === "preview") {
      formNoti.setFieldValue(["preview"], {
        isActive: formNoti.getFieldValue(["preview", "isActive"]),
        title: "⚡เปิดให้ชมสินค้า Flash Sale ล่วงหน้า",
        detail: `สินค้า ${mapCompanyName[company]} 📦 เปิดให้ดูรายการสินค้าล่วงหน้าแล้ว แวะดูรายการสินค้าได้ก่อนใคร และรอเตรียมตัวช้อปได้เลย`,
      });
    }
    if (type === "countdown") {
      formNoti.setFieldValue(["countdown"], {
        isActive: formNoti.getFieldValue(["countdown", "isActive"]),
        countDownType: "MIN_60",
        title: "🔥 นับถอยหลังเริ่มช้อป 🔥",
        detail: `เวลา ${dayjs(form.getFieldValue(["rounds", 0]).startTime)
          .locale("th")
          .format("HH:mm")} น. วันนี้`,
      });
    }
    if (type === "roundNoti") {
      formNoti.setFieldValue(["roundNoti", "rounds", round ?? 0], {
        ...formNoti.getFieldValue(["roundNoti", "rounds", round ?? 0]),
        title: `⚡ Flash Sale รอบที่ ${Math.round(round ?? 0) + 1} เริ่มแล้ว`,
        detail: `สินค้า ${mapCompanyName[company]} ดีลพิเศษมีจำนวนจำกัด แวะดูรายการทั้งหมดได้ในแอปตอนนี้`,
      });
    }
  };

  const fetchCompanyList = async () => {
    const result = await getCompanyList();
    setCompanyList(result);
  };

  const fetchProBrand = async () => {
    await shopDatasource.getBrandList(company).then((res) => {
      const find = res.find((item) => `${item.productBrandId}` === `${brandId}`);
      setProdBrandData(find);
    });
  };

  useEffectOnce(() => {
    fetchCompanyList();
  });

  useEffect(() => {
    fetchProBrand();
  }, [brandId]);

  const fetchNotification = async () => {
    try {
      const result = await getFlashSaleNotification(flashSaleId);
      setNotiInfo(result);
      const mapPreview = {
        ...result.preview,
        isDisabled: dateToday > dayjs(result.preview.sendAt).locale("th").toISOString(),
      };
      const mapCountdown = {
        ...result.countdown,
        isDisabled: dateToday > dayjs(result.countdown.sendAt).locale("th").toISOString(),
      };

      const mapRoundNoti = {
        ...result.roundNoti,
        isDisabled:
          dateToday >
          dayjs(result.roundNoti.rounds[result.roundNoti.rounds.length - 1].sendAt)
            .locale("th")
            .toISOString(),
        rounds: result.roundNoti.rounds.map((round) => ({
          ...round,
          isDisabled: dateToday > dayjs(round.sendAt).locale("th").toISOString(),
        })),
      };

      formNoti.setFieldsValue({
        ...result,
        preview: mapPreview,
        countdown: mapCountdown,
        roundNoti: mapRoundNoti,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchNotification();
  }, [flashSaleId]);

  const resetNotification = (type: "preview" | "countdown" | "roundNoti", round?: number) => {
    switch (type) {
      case "preview":
        formNoti.setFieldValue([type], notiInfo.preview);
        break;
      case "countdown":
        formNoti.setFieldValue([type], notiInfo.countdown);
        break;
      case "roundNoti":
        formNoti.setFieldValue([type, "rounds", round ?? 0], notiInfo.roundNoti.rounds[round ?? 0]);
        break;
    }
  };

  const onSubmitNoti = async (category: string, round?: number) => {
    try {
      (await category) !== "roundNoti"
        ? formNoti.validateFields([
            [category, "title"],
            [category, "detail"],
          ])
        : formNoti.validateFields([
            [category, "rounds", round, "title"],
            [category, "rounds", round, "detail"],
          ]);
      const values = formNoti.getFieldValue([category]);
      const payload =
        category === "roundNoti"
          ? {
              flashSaleId: flashSaleId,
              isActive: values.isActive,
              updateBy: profile.firstname + " " + profile.lastname,
              rounds: [
                {
                  flashSaleRoundId: values.rounds[round ?? 0].flashSaleRoundId,
                  title: values.rounds[round ?? 0].title,
                  detail: values.rounds[round ?? 0].detail,
                },
              ],
            }
          : {
              title: values.title,
              detail: values.detail,
              isActive: values.isActive,
              flashSaleId: flashSaleId,
              updateBy: profile.firstname + " " + profile.lastname,
              countDownType: values.countDownType,
            };
      if (category === "preview") {
        await updateNotiPreview(payload).then((res) => {
          if (res.success) {
            messageApi.success("บันทึกสำเร็จ");
          }
        });
      }
      if (category === "countdown") {
        await updateNotiCountdown(payload).then((res) => {
          if (res.success) {
            messageApi.success("บันทึกสำเร็จ");
          }
        });
      }
      if (category === "roundNoti") {
        await updateNotiRound(payload).then((res) => {
          if (res.success) {
            messageApi.success("บันทึกสำเร็จ");
          }
        });
      }
      fetchNotification();
    } catch (error) {
      console.log("Validation Failed:", error);
    }
  };

  return (
    <Form form={formNoti} layout='vertical'>
      {/* preview */}
      <StyledCollapse
        activeKey={formNoti.getFieldValue(["preview", "isActive"]) ? ["1"] : []}
        items={[
          {
            key: "1",
            label: (
              <>
                <Row gutter={16} align='middle'>
                  <Col>
                    <Form.Item name={["preview", "isActive"]} noStyle>
                      <Switch
                        disabled={
                          !formNoti.getFieldValue("preview") ||
                          formNoti.getFieldValue(["preview", "isDisabled"])
                        }
                        onChange={(checked) => {
                          formNoti.setFieldValue(["preview", "isActive"], checked);
                          onSubmitNoti("preview");
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Text fontWeight={600}>
                      เปิดใช้งาน แจ้งเตือน - ร้านเริ่มเห็น Flash Sale ล่วงหน้า
                    </Text>
                    <br />
                    <Text color='Text3' level={6}>
                      ส่งอัตโนมัติเมื่อถึงเวลาเริ่มเห็นแคมเปญล่วงหน้า แสดงบนหน้า Lock-Screen
                      และเมนูแจ้งเตือนใน Shop App
                    </Text>
                  </Col>
                </Row>
              </>
            ),
            showArrow: false,
            children: (
              <>
                {(() => {
                  const isDisabled = formNoti.getFieldValue(["preview", "isDisabled"]);
                  return (
                    <Row justify='space-between' gutter={16}>
                      <Col span={16}>
                        <Row
                          gutter={8}
                          justify='space-between'
                          align='middle'
                          style={{ marginBottom: 10 }}
                        >
                          <Col>
                            <Text fontWeight={700}>ข้อความแจ้งเตือน</Text>
                            <br />
                            <Text fontWeight={700}>
                              เมื่อถึงวันที่{" "}
                              {dayjs(formNoti.getFieldValue(["preview", "sendAt"]))
                                .locale("th")
                                .add(543, "year")
                                .format("DD MMM YYYY (HH:mm)")}
                            </Text>
                          </Col>
                          <Col>
                            <Button
                              typeButton={isDisabled ? "border-light" : "primary-light"}
                              title='คืนค่าเริ่มต้น'
                              height={32}
                              disabled={isDisabled}
                              onClick={() => !isDisabled && defaultNotiInfo("preview")}
                            />
                          </Col>
                        </Row>
                        <Row
                          gutter={8}
                          justify='space-between'
                          align='middle'
                          style={{ marginBottom: 10 }}
                        >
                          <Col span={24}>
                            <Form.Item
                              name={["preview", "title"]}
                              label='ชื่อเรื่อง (Title)'
                              rules={[{ required: true, message: "โปรดระบุชื่อเรื่อง" }]}
                            >
                              <Input
                                showCount
                                maxLength={50}
                                style={{ width: "100%", height: "40px" }}
                                autoComplete='off'
                                disabled={isDisabled}
                              />
                            </Form.Item>
                            <Text color='Text3' level={6}>
                              แนะนำ 25-35 ตัวอักษร · สูงสุด 50
                            </Text>
                          </Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                          <Space wrap>
                            {[
                              "🔥 Flash Sale เปิดให้ดูล่วงหน้าแล้ว",
                              "👀 ดูสินค้า Flash Sale ล่วงหน้าได้แล้ว",
                              "⚡ ดูสินค้า Flash Sale ก่อนใคร",
                            ]
                              .filter(
                                (item) => item !== formNoti.getFieldValue(["preview", "title"]),
                              )
                              .map((item) => (
                                <ButtonAntd
                                  disabled={isDisabled}
                                  key={item}
                                  icon={<PlusOutlined />}
                                  style={{ borderRadius: "100px" }}
                                  onClick={() => {
                                    if (!isDisabled) {
                                      formNoti.setFieldsValue({
                                        preview: {
                                          title: item,
                                        },
                                      });
                                    }
                                  }}
                                >
                                  {item}
                                </ButtonAntd>
                              ))}
                          </Space>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                          <Col span={24}>
                            <Form.Item
                              name={["preview", "detail"]}
                              label='รายละเอียด (Detail)'
                              rules={[{ required: true, message: "โปรดระบุรายละเอียด" }]}
                            >
                              <TextArea
                                showCount
                                maxLength={150}
                                style={{ height: 120, resize: "none" }}
                                autoComplete='off'
                                disabled={isDisabled}
                              />
                            </Form.Item>
                            <Text color='Text3' level={6}>
                              แนะนำ 80-120 ตัวอักษร · สูงสุด 150
                            </Text>
                          </Col>
                        </Row>
                        <Row justify='end' align='middle' gutter={8}>
                          <Col>
                            <Button
                              typeButton={isDisabled ? "light-disabled" : "primary-no-border"}
                              title='ยกเลิก'
                              disabled={isDisabled}
                              onClick={() => !isDisabled && resetNotification("preview")}
                            />
                          </Col>
                          <Col>
                            <Button
                              typeButton={isDisabled ? "disabled" : "primary"}
                              title='บันทึก'
                              disabled={isDisabled}
                              onClick={() => !isDisabled && onSubmitNoti("preview")}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}>
                        <div
                          style={{
                            backgroundColor: "#EFF2F9",
                            position: "relative",
                            maxWidth: "500px",
                            height: "450px",
                            paddingBottom: "16px",
                            paddingLeft: "16px",
                            paddingRight: "16px",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={image.flash_sale_phone_screen}
                            alt='Flash Sale Phone Screen'
                            style={{
                              width: "100%",
                              height: "100%",
                              //objectFit: "contain",
                              display: "block",
                            }}
                          />

                          <Card
                            bodyStyle={{
                              padding: "clamp(10px, 3%, 20px)",
                            }}
                            style={{
                              position: "absolute",
                              top: "60%",
                              left: "10%",
                              right: "10%",
                              transform: "translateY(-50%)",
                              borderRadius: "clamp(16px, 4%, 24px)",
                            }}
                          >
                            <Row align='middle' gutter={8} wrap={false}>
                              <Col flex='0 0 20%'>
                                <img
                                  src={image.iconShopApp}
                                  style={{
                                    width: "100%",
                                    height: "auto",
                                    objectFit: "contain",
                                  }}
                                />
                              </Col>

                              <Col flex='1'>
                                <div
                                  style={{
                                    fontSize: "clamp(12px, 2vw, 20px)",
                                    lineHeight: 1,
                                  }}
                                >
                                  <Text level={6} fontWeight={700}>
                                    {previewTitle}
                                  </Text>
                                </div>

                                <div
                                  style={{
                                    fontSize: "clamp(11px, 1.8vw, 18px)",
                                    lineHeight: 1,
                                  }}
                                >
                                  <Text level={6}>{previewDetail}</Text>
                                </div>
                              </Col>
                            </Row>
                          </Card>
                        </div>
                      </Col>
                    </Row>
                  );
                })()}
              </>
            ),
          },
        ]}
      />
      <br />
      {/* countdown */}
      <StyledCollapse
        activeKey={formNoti.getFieldValue(["countdown", "isActive"]) ? ["1"] : []}
        items={[
          {
            key: "1",
            label: (
              <>
                <Row gutter={16} align='middle'>
                  <Col>
                    <Form.Item name={["countdown", "isActive"]} noStyle>
                      <Switch
                        disabled={
                          !formNoti.getFieldValue("countdown") ||
                          formNoti.getFieldValue(["countdown", "isDisabled"])
                        }
                        onChange={(checked) => {
                          formNoti.setFieldValue(["countdown", "isActive"], checked);
                          onSubmitNoti("countdown");
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Text fontWeight={600}>เปิดใช้งาน แจ้งเตือน - Countdown Flash Sale</Text>
                    <br />
                    <Text color='Text3' level={6}>
                      แสดงเวลานับถอย (Pre-Launch) ก่อนแคมเปญขายรอบแรก หน้า Lock-Screen มือถือ
                    </Text>
                  </Col>
                </Row>
              </>
            ),
            showArrow: false,
            children: (
              <>
                {(() => {
                  const isDisabled = formNoti.getFieldValue(["countdown", "isDisabled"]);
                  return (
                    <Row justify='space-between' gutter={16}>
                      <Col span={16}>
                        <Row
                          gutter={8}
                          justify='space-between'
                          align='middle'
                          style={{ marginBottom: 10 }}
                        >
                          <Col span={10}>
                            <Form.Item
                              name={["countdown", "countDownType"]}
                              label='เวลานับถอยหลังก่อนเริ่ม'
                              required
                            >
                              <Select
                                disabled={isDisabled}
                                allowClear={false}
                                style={{ width: "100%" }}
                                data={[
                                  { label: "15 นาที", value: "MIN_15", key: "MIN_15" },
                                  { label: "30 นาที", value: "MIN_30", key: "MIN_30" },
                                  { label: "60 นาที", value: "MIN_60", key: "MIN_60" },
                                ]}
                              />
                            </Form.Item>
                          </Col>
                          <Col>
                            <Button
                              typeButton={isDisabled ? "border-light" : "primary-light"}
                              title='คืนค่าเริ่มต้น'
                              height={32}
                              onClick={() => defaultNotiInfo("countdown")}
                              disabled={isDisabled}
                            />
                          </Col>
                        </Row>
                        <Row
                          gutter={8}
                          justify='space-between'
                          align='middle'
                          style={{ marginBottom: 10 }}
                        >
                          <Col span={24}>
                            <Form.Item
                              name={["countdown", "title"]}
                              label='ชื่อเรื่อง (Title)'
                              required
                              rules={[{ required: true, message: "โปรดระบุชื่อเรื่อง" }]}
                            >
                              <Input
                                showCount
                                maxLength={35}
                                style={{ width: "100%", height: "40px" }}
                                autoComplete='off'
                                disabled={isDisabled}
                              />
                            </Form.Item>
                            <Text color='Text3' level={6}>
                              แนะนำ 20-30 ตัวอักษร · สูงสุด 35
                            </Text>
                          </Col>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                          <Space wrap>
                            {["🔥 เตรียมตัวช้อป", "⚡ ใกล้เริ่มแล้ว", "⏰ อีกไม่นานเริ่มช้อปแล้ว"]
                              .filter(
                                (item) => item !== formNoti.getFieldValue(["countdown", "title"]),
                              )
                              .map((item) => (
                                <ButtonAntd
                                  key={item}
                                  icon={<PlusOutlined />}
                                  style={{ borderRadius: "100px" }}
                                  onClick={() => {
                                    formNoti.setFieldsValue({
                                      countdown: {
                                        title: item,
                                      },
                                    });
                                  }}
                                  disabled={isDisabled}
                                >
                                  {item}
                                </ButtonAntd>
                              ))}
                          </Space>
                        </Row>
                        <Row style={{ marginBottom: 10 }}>
                          <Col span={24}>
                            <Form.Item
                              name={["countdown", "detail"]}
                              label='รายละเอียด (Detail)'
                              required
                              rules={[{ required: true, message: "โปรดระบุรายละเอียด" }]}
                            >
                              <Input
                                showCount
                                maxLength={40}
                                style={{ width: "100%", height: "40px" }}
                                autoComplete='off'
                                disabled={isDisabled}
                              />
                            </Form.Item>
                            <Text color='Text3' level={6}>
                              แนะนำ 25-35 ตัวอักษร · สูงสุด 40
                            </Text>
                          </Col>
                        </Row>
                        <Row justify='end' align='middle' gutter={8}>
                          <Col>
                            <Button
                              typeButton={isDisabled ? "light-disabled" : "primary-no-border"}
                              disabled={isDisabled}
                              title='ยกเลิก'
                              onClick={() => resetNotification("countdown")}
                            />
                          </Col>
                          <Col>
                            <Button
                              typeButton={isDisabled ? "disabled" : "primary"}
                              disabled={isDisabled}
                              title='บันทึก'
                              onClick={() => onSubmitNoti("countdown")}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col span={8}>
                        <div
                          style={{
                            backgroundColor: "#EFF2F9",
                            position: "relative",
                            maxWidth: "500px",
                            height: "450px",
                            padding: "0 16px 16px",
                            borderRadius: "8px",
                            overflow: "hidden",
                          }}
                        >
                          <img
                            src={image.flash_sale_phone_screen}
                            alt='Flash Sale Phone Screen'
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "contain",
                              display: "block",
                            }}
                          />

                          <img
                            src={
                              company === "ICPF" || (company === "ICPL" && brandId === 6)
                                ? image.flash_sale_countdown_red
                                : image.flash_sale_countdown_blue
                            }
                            alt='Flash Sale Countdown'
                            style={{
                              position: "absolute",
                              width: "80%",
                              height: "auto",
                              top: "60%",
                              left: "50%",
                              transform: "translate(-50%, -50%)",
                            }}
                          />
                          <img
                            src={
                              companyList.find((c) => `${c.companyCode}` === `${company}`)
                                ?.companyLogo
                            }
                            alt='Company Logo'
                            style={{
                              position: "absolute",
                              width: "7%",
                              height: "5.5%",
                              objectFit: "contain",
                              top: "48%",
                              left: "13.5%",
                            }}
                          />
                          <div
                            style={{
                              position: "absolute",
                              top: "50%",
                              left: "24%",
                              width: "70%",
                            }}
                          >
                            <Text
                              level={6}
                              color='white'
                              style={{
                                fontSize: "clamp(12px, 1.5vw, 20px)",
                                lineHeight: 1,
                              }}
                            >
                              {mapCompanyName[company]}-{prodBrandData?.productBrandName}
                            </Text>
                          </div>
                          <div
                            style={{
                              position: "absolute",
                              width: "70%",
                              left: "15%",
                              bottom: "27.8%",
                            }}
                          >
                            <Row justify='space-between' align='middle'>
                              <Col span={15}>
                                <Text level={6} color='BK' fontWeight={600}>
                                  {countdownTitle}
                                </Text>
                                <br />
                                <Text level={6} color='BK'>
                                  {countdownDetail}
                                </Text>
                              </Col>
                              <Col>
                                <Text level={1} color='BK' fontWeight={600}>
                                  {mapCountdown[countdownType]}
                                </Text>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  );
                })()}
              </>
            ),
          },
        ]}
      />
      <br />
      {/* roundNoti */}
      <StyledCollapse
        activeKey={formNoti.getFieldValue(["roundNoti", "isActive"]) ? ["1"] : []}
        items={[
          {
            key: "1",
            label: (
              <>
                <Row gutter={16} align='middle'>
                  <Col>
                    <Form.Item name={["roundNoti", "isActive"]} noStyle>
                      <Switch
                        disabled={
                          formNoti.getFieldValue(["roundNoti", "rounds"])?.length === 0 ||
                          formNoti.getFieldValue(["roundNoti", "isDisabled"])
                        }
                        onChange={(checked) => {
                          formNoti.setFieldValue(["roundNoti", "isActive"], checked);
                          onSubmitNoti("roundNoti");
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Text fontWeight={600}>เปิดใช้งาน แจ้งเตือน - เริ่มรอบขาย Flash Sale</Text>
                    <br />
                    <Text color='Text3' level={6}>
                      ส่งอัตโนมัติเมื่อถึงเวลาเริ่มขายแต่ละรอบ แสดงบนหน้า Lock-Screen
                      และเมนูแจ้งเตือนใน Shop App
                    </Text>
                  </Col>
                </Row>
              </>
            ),
            showArrow: false,
            children: (
              <>
                <div style={{ marginBottom: 10 }}>
                  <Radio.Group>
                    {formNoti?.getFieldsValue(true)?.roundNoti?.rounds &&
                      formNoti
                        .getFieldsValue(true)
                        ?.roundNoti?.rounds.map((round: any, index: number) => (
                          <Radio.Button
                            key={index}
                            value={currentRound}
                            onClick={() => setCurrentRound(index)}
                            style={{ borderColor: currentRound === index ? "#1890ff" : undefined }}
                          >
                            <Text color={currentRound === index ? "primary" : undefined}>
                              รอบที่ {round.roundNo}
                            </Text>
                          </Radio.Button>
                        ))}
                  </Radio.Group>
                </div>
                <>
                  {(() => {
                    const isDisabled =
                      formNoti?.getFieldsValue(true)?.roundNoti?.rounds?.[currentRound].isDisabled;
                    return (
                      <Row justify='space-between' gutter={16}>
                        <Col span={16}>
                          <Row
                            gutter={8}
                            justify='space-between'
                            align='middle'
                            style={{ marginBottom: 10 }}
                          >
                            <FlexCol>
                              <Text fontWeight={700}>ข้อความแจ้งเตือน</Text>
                              <Row>
                                <Form.Item
                                  name={["roundNoti", "rounds", currentRound, "roundNo"]}
                                  noStyle
                                >
                                  <Text fontWeight={700}>
                                    เมื่อถึงรอบที่ {watchRounds?.roundNo} ·
                                  </Text>
                                </Form.Item>
                                &nbsp;
                                <Form.Item
                                  name={["roundNoti", "rounds", currentRound, "startDate"]}
                                  noStyle
                                >
                                  <Text fontWeight={700}>
                                    {dayjs(watchRounds?.startDate)
                                      .locale("th")
                                      .add(543, "year")
                                      .format("DD MMM YYYY (HH:mm)")}{" "}
                                  </Text>
                                </Form.Item>
                                <Text fontWeight={700}> - </Text>
                                <Form.Item
                                  name={["roundNoti", "rounds", currentRound, "endDate"]}
                                  noStyle
                                >
                                  <Text fontWeight={700}>
                                    {dayjs(watchRounds?.endDate)
                                      .locale("th")
                                      .add(543, "year")
                                      .format("DD MMM YYYY (HH:mm)")}
                                  </Text>
                                </Form.Item>
                              </Row>
                            </FlexCol>
                            <Col>
                              <Button
                                typeButton={isDisabled ? "border-light" : "primary-light"}
                                title='คืนค่าเริ่มต้น'
                                disabled={isDisabled}
                                height={32}
                                onClick={() => defaultNotiInfo("roundNoti", currentRound)}
                              />
                            </Col>
                          </Row>
                          <Row
                            gutter={8}
                            justify='space-between'
                            align='middle'
                            style={{ marginBottom: 10 }}
                          >
                            <Col span={24}>
                              <Form.Item
                                name={["roundNoti", "rounds", currentRound, "title"]}
                                label='ชื่อเรื่อง (Title)'
                                rules={[{ required: true, message: "โปรดระบุชื่อเรื่อง" }]}
                              >
                                <Input
                                  showCount
                                  maxLength={50}
                                  style={{ width: "100%", height: "40px" }}
                                  autoComplete='off'
                                  disabled={isDisabled}
                                />
                              </Form.Item>
                              <Text color='Text3' level={6}>
                                แนะนำ 25-35 ตัวอักษร · สูงสุด 50
                              </Text>
                            </Col>
                          </Row>
                          <Row style={{ marginBottom: 10 }}>
                            <Space wrap>
                              {[
                                `🔥 เริ่มแล้ว! Flash Sale รอบที่ ${watchRounds?.roundNo} รีบช้อปเลย`,
                                `⚡ ดีลพิเศษรอบที่ ${watchRounds?.roundNo} เริ่มแล้ว`,
                                `🎉 Flash Sale รอบที่ ${watchRounds?.roundNo} เริ่มแล้ว รีบคว้าก่อนใคร`,
                              ]
                                .filter(
                                  (item) =>
                                    item !==
                                    formNoti.getFieldValue([
                                      "roundNoti",
                                      "rounds",
                                      currentRound,
                                      "title",
                                    ]),
                                )
                                .map((item) => (
                                  <ButtonAntd
                                    key={item}
                                    icon={<PlusOutlined />}
                                    style={{ borderRadius: "100px" }}
                                    disabled={isDisabled}
                                    onClick={() => {
                                      formNoti.setFieldsValue({
                                        roundNoti: {
                                          rounds: {
                                            [currentRound]: {
                                              title: item,
                                            },
                                          },
                                        },
                                      });
                                    }}
                                  >
                                    {item}
                                  </ButtonAntd>
                                ))}
                            </Space>
                          </Row>
                          <Row style={{ marginBottom: 10 }}>
                            <Col span={24}>
                              <Form.Item
                                name={["roundNoti", "rounds", currentRound, "detail"]}
                                label='รายละเอียด (Detail)'
                                rules={[{ required: true, message: "โปรดระบุรายละเอียด" }]}
                              >
                                <TextArea
                                  showCount
                                  maxLength={150}
                                  style={{ height: 120, resize: "none" }}
                                  autoComplete='off'
                                  disabled={isDisabled}
                                />
                              </Form.Item>
                              <Text color='Text3' level={6}>
                                แนะนำ 80-120 ตัวอักษร · สูงสุด 150
                              </Text>
                            </Col>
                          </Row>
                          <Row justify='end' align='middle' gutter={8}>
                            <Col>
                              <Button
                                typeButton={isDisabled ? "light-disabled" : "primary-no-border"}
                                title='ยกเลิก'
                                disabled={isDisabled}
                                onClick={() =>
                                  isDisabled && resetNotification("roundNoti", currentRound)
                                }
                              />
                            </Col>
                            <Col>
                              <Button
                                typeButton={isDisabled ? "disabled" : "primary"}
                                title='บันทึก'
                                disabled={isDisabled}
                                onClick={() =>
                                  !isDisabled && onSubmitNoti("roundNoti", currentRound)
                                }
                              />
                            </Col>
                          </Row>
                        </Col>
                        <Col span={8}>
                          <div
                            style={{
                              backgroundColor: "#EFF2F9",
                              position: "relative",
                              height: "450px",
                              maxWidth: "500px",
                              paddingBottom: "16px",
                              paddingLeft: "16px",
                              paddingRight: "16px",
                              borderRadius: "8px",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={image.flash_sale_phone_screen}
                              alt='Flash Sale Phone Screen'
                              style={{
                                width: "100%",
                                height: "100%",
                                //objectFit: "contain",
                              }}
                            />

                            <Card
                              bodyStyle={{
                                padding: "clamp(10px, 3%, 20px)",
                              }}
                              style={{
                                position: "absolute",
                                top: "60%",
                                left: "10%",
                                right: "10%",
                                transform: "translateY(-50%)",
                                borderRadius: "clamp(16px, 4%, 24px)",
                              }}
                            >
                              <Row align='middle' gutter={8} wrap={false}>
                                <Col flex='0 0 20%'>
                                  <img
                                    src={image.iconShopApp}
                                    style={{
                                      width: "100%",
                                      height: "auto",
                                      objectFit: "contain",
                                    }}
                                  />
                                </Col>
                                <Col flex='1'>
                                  <div
                                    style={{
                                      fontSize: "clamp(12px, 2vw, 20px)",
                                      lineHeight: 1,
                                    }}
                                  >
                                    <Text level={6} fontWeight={700}>
                                      {watchRounds?.title}
                                    </Text>
                                  </div>

                                  <div
                                    style={{
                                      fontSize: "clamp(11px, 1.8vw, 18px)",
                                      lineHeight: 1,
                                    }}
                                  >
                                    <Text level={6}>{watchRounds?.detail}</Text>
                                  </div>
                                </Col>
                              </Row>
                            </Card>
                          </div>
                        </Col>
                      </Row>
                    );
                  })()}
                </>
              </>
            ),
          },
        ]}
      />
    </Form>
  );
};

const HighlightFlashSale = ({
  form,
  highLightNewsId,
  setLoading,
}: {
  form: any;
  highLightNewsId: string;
  setLoading: any;
}) => {
  const profile = JSON.parse(localStorage.getItem("profile")!);
  const { messageApi } = useMessageContext();
  const [formHighlight] = Form.useForm();
  const [shopList, setShopList] = useState<any[]>([]);
  const watchFileUrl = Form.useWatch("fileUrl", formHighlight);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [modalHighlightDup, setModalHighlightDup] = useState<any>({ open: false, data: [] });

  const fetchData = async () => {
    const { responseData } = await getHighlightById(highLightNewsId);
    formHighlight.setFieldsValue({
      ...responseData,
      startDate: dayjs(responseData?.startDate),
      endDate: dayjs(responseData?.endDate),
      startTime: dayjs(responseData?.startDate),
      endTime: dayjs(responseData?.endDate),
      status: responseData?.status,
      fileImage: responseData?.newsImage,
      fileUrl: responseData?.newsImage,
      isDup: undefined,
      type: responseData?.type,
    });
  };

  const fetchShopList = async () => {
    const shopList = await getShopListByFlashSaleId(form.getFieldValue("flashSaleId"));
    setShopList(shopList);
  };

  useEffect(() => {
    fetchData();
    fetchShopList();
  }, [highLightNewsId, formHighlight]);

  const onCreateHighlight = async () => {
    setLoading(true);
    try {
      await formHighlight.validateFields();
      const dataForm = formHighlight.getFieldsValue(true);
      let imgUrl = dataForm.fileUrl;
      if (dataForm.fileImage instanceof File) {
        imgUrl = await convertImageFlashSale(dataForm.fileImage).then((res) => {
          return res?.url || "";
        });
      }
      const formData = new FormData();
      formData.append("highlightNewsId", highLightNewsId);
      formData.append("image", imgUrl);
      formData.append("company", dataForm.company);
      formData.append("topic", dataForm.topic);
      formData.append(
        "startDate",
        dayjs(
          `${dayjs(dataForm.startDate).format("YYYY-MM-DD")} ${dayjs(dataForm.startTime).format("HH:mm")}`,
        ).toISOString(),
      );
      formData.append(
        "endDate",
        dayjs(
          `${dayjs(dataForm.endDate).format("YYYY-MM-DD")} ${dayjs(dataForm.endTime).format("HH:mm")}`,
        ).toISOString(),
      );
      formData.append("isShowOnSaleApp", "true");
      formData.append("isShowOnShopApp", "true");
      formData.append("status", dataForm.status);
      formData.append("createdBy", profile.firstname + " " + profile.lastname);
      formData.append("updateBy", profile.firstname + " " + profile.lastname);
      formData.append("flashSaleId", dataForm.flashSaleId);

      await createHighlightFlashSale(formData)
        .then((res) => {
          if (res.success) {
            setTimeout(() => setLoading(false), 300);
            messageApi.success("บันทึกสำเร็จ");
            fetchData();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Form form={formHighlight} layout='vertical'>
        <Row justify='space-between' gutter={16}>
          <Col span={15} style={{ padding: "12px" }}>
            <div style={{ padding: "12px" }}>
              <Row>
                <Col span={5}>
                  <CustomFormItem
                    name='fileUrl'
                    valuePropName='file'
                    rules={[
                      {
                        required: true,
                        message: "*กรุณาเพิ่มรูป",
                      },
                    ]}
                  >
                    <ImgCrop aspect={4 / 5} {...imgCropProps}>
                      <UploadVeritical
                        listType='picture-card'
                        maxCount={1}
                        beforeUpload={(file) => {
                          const isJpgOrPng =
                            file.type === "image/jpeg" || file.type === "image/png";
                          if (!isJpgOrPng) {
                            message.error("You can only upload JPG/PNG file!");
                            return true;
                          }
                          formHighlight.setFieldValue("fileImage", file);
                          getBase64(file as RcFile, (url) => {
                            formHighlight.setFieldValue("fileUrl", url);
                          });
                          return false;
                        }}
                        customRequest={({ file }) => {
                          console.log("customRequest", file);
                        }}
                        onChange={({ file }: any) => {
                          return "success";
                        }}
                        onRemove={() => {
                          formHighlight.setFieldValue("fileImage", undefined);
                        }}
                        showUploadList={false}
                        disabled={
                          !!formHighlight.getFieldValue("fileImage") ||
                          !!formHighlight.getFieldValue("fileUrl") ||
                          !highLightNewsId
                        }
                      >
                        {!formHighlight.getFieldValue("fileUrl") ||
                        !formHighlight.getFieldValue("fileImage") ? (
                          <UploadArea
                            style={{
                              width: "120px",
                              height: "160px",
                            }}
                          >
                            {UploadIcon}
                          </UploadArea>
                        ) : (
                          <Form.Item name='fileUrl' noStyle>
                            <ImageWithDeleteButton
                              width='120px'
                              height='160px'
                              src={formHighlight?.getFieldValue("fileUrl")}
                              handleDelete={() => {
                                formHighlight.setFieldValue("fileImage", undefined);
                                formHighlight.setFieldValue("fileUrl", undefined);
                              }}
                            />
                          </Form.Item>
                        )}
                      </UploadVeritical>
                    </ImgCrop>
                  </CustomFormItem>
                </Col>
                <Col span={18}>
                  <Text level={6}>รูปภาพประกอบไฮไลท์</Text>
                  <br />
                  <Text level={6} color='Text3'>
                    JPG, GIF or PNG. Size of
                    <br />
                    1200*1500px
                    <br />
                    4:5
                  </Text>
                </Col>
              </Row>
            </div>
            <br />
            <Row>
              <Col span={24}>
                <Form.Item
                  name='topic'
                  label='ชื่อข่าวสาร'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดระบุชื่อข่าวสาร",
                    },
                    {
                      max: 50,
                      message: "*ชื่อข่าวสารต้องมีความยาวไม่เกิน 50 ตัวอักษร",
                    },
                  ]}
                >
                  <Input
                    placeholder='ระบุชื่อข่าวสาร'
                    style={{ width: "100%" }}
                    autoComplete='off'
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={12}>
              <Col span={6}>
                <Form.Item
                  name='startDate'
                  label='วันที่เริ่มเผยแพร่'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกวันที่เริ่มโปรโมชัน",
                    },
                  ]}
                >
                  <DatePicker style={{ width: "100%", color: color.BK }} disabled={true} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name='startTime'
                  label='เวลาเริ่ม'
                  initialValue={dayjs("00:00", "HH:mm")}
                >
                  <TimePicker
                    allowClear={false}
                    style={{ width: "100%", color: color.BK }}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name='endDate'
                  label='วันที่สิ้นสุดเผยแพร่'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกวันที่สิ้นสุดโปรโมชัน",
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: "100%", color: color.BK }}
                    disabled={true}
                    disabledDate={(current: Dayjs) => {
                      const startDate = form.getFieldValue("startDate");
                      return current && current.isBefore(dayjs(startDate));
                    }}
                    enablePast
                  />
                </Form.Item>
              </Col>
              <Col span={6}>
                <Form.Item
                  name='endTime'
                  label='เวลาสิ้นสุด'
                  initialValue={dayjs("23:59", "HH:mm")}
                >
                  <TimePicker
                    allowClear={false}
                    style={{ width: "100%", color: color.BK }}
                    disabled={true}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Text level={5} fontWeight={700}>
                  <span style={{ color: color.error }}>*</span> แอปพลิเคชัน
                </Text>
                <Form.Item
                  name='isShowOnSaleApp'
                  valuePropName='checked'
                  noStyle
                  initialValue={true}
                  rules={[
                    {
                      validator(rule, value, callback) {
                        if (!value && !form.getFieldValue("isShowOnShopApp")) {
                          return Promise.reject("กรุณาเลือก");
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Checkbox disabled={true}>Sale App</Checkbox>
                </Form.Item>
                <Form.Item
                  name='isShowOnShopApp'
                  valuePropName='checked'
                  noStyle
                  initialValue={true}
                  rules={[
                    {
                      validator(rule, value, callback) {
                        if (!value && !form.getFieldValue("isShowOnSaleApp")) {
                          return Promise.reject("กรุณาเลือก");
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Checkbox disabled={true}>Shop App</Checkbox>
                </Form.Item>
              </Col>
            </Row>
            <br />
            <Row>
              <Col span={24}>
                <Text level={5} fontWeight={700}>
                  <span style={{ color: color.error }}>*</span> สถานะ
                </Text>
                <Form.Item
                  name='status'
                  rules={[
                    {
                      required: true,
                      message: "*โปรดเลือกสถานะ",
                    },
                  ]}
                >
                  <Radio.Group style={{ width: "100%" }}>
                    <Space direction='vertical' style={{ width: "100%" }}>
                      <Radio value='PUBLISHED' disabled={!highLightNewsId}>
                        เปิดใช้งาน
                      </Radio>
                      <Radio value='INACTIVE' disabled={!highLightNewsId}>
                        ปิดใช้งาน
                      </Radio>
                    </Space>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col span={8}>
            <ReviewHighLightNews imageUrl={formHighlight.getFieldValue("fileUrl")} />
          </Col>
        </Row>
      </Form>
      <Divider />
      <Row justify='end'>
        <Col>
          <Button
            typeButton={!highLightNewsId ? "disabled" : "primary"}
            title='บันทึก'
            onClick={() => {
              highLightNewsId &&
                (async () => {
                  const status = formHighlight.getFieldValue("status");
                  let isHighLightDup: any = { isDup: false, data: [] };
                  const checkDup = await checkDuplicateHighlight(
                    form.getFieldValue("previewDate"),
                    form.getFieldValue("mainEndDate"),
                    shopList,
                    form.getFieldValue("highLightNewsId") || null,
                  );
                  const groupedNew =
                    checkDup?.length > 0
                      ? checkDup.reduce((acc: any, item: any) => {
                          const key = item.highlightNews.highlightNewsId;
                          if (!acc[key]) {
                            acc[key] = {
                              ...item.highlightNews,
                              shops: [],
                            };
                          }
                          acc[key].shops.push({
                            highlightNewsShopId: item.highlightNewsShopId,
                            customerCompanyId: item.customerCompanyId,
                            customerNo: item.customerNo,
                            customerName: item.customerName,
                            zone: item.zone,
                            customerGroupName: item.customerGroupName,
                          });
                          return acc;
                        }, {})
                      : {};
                  const DupNewsList = Object.values(groupedNew);
                  isHighLightDup = { isDup: checkDup?.length > 0, data: DupNewsList || [] };
                  isHighLightDup.isDup && status === "PUBLISHED"
                    ? setModalHighlightDup({ open: true, data: isHighLightDup.data })
                    : setModalConfirm(true);
                })();
            }}
          />
        </Col>
      </Row>
      {modalConfirm && (
        <Modal
          open={modalConfirm}
          onOk={async () => {
            onCreateHighlight();
            setModalConfirm(false);
          }}
          onCancel={() => setModalConfirm(false)}
          centered
          cancelText='ยกเลิก'
          okText='ยืนยัน'
          okButtonProps={{
            style: {
              backgroundColor: color.primary,
              borderColor: color.primary,
            },
          }}
          cancelButtonProps={{
            style: {
              borderColor: color.primary,
              color: color.primary,
            },
          }}
        >
          <Text level={2} fontWeight={600}>
            ยืนยันการบันทึกไฮไลท์ข่าวสาร
          </Text>
          <br />
          <Text color='Text3'>โปรดตรวจสอบรายละเอียดการตั้งค่าอีกครั้งก่อนกดยืนยัน</Text>
          <Divider size='small' />
        </Modal>
      )}
      {modalHighlightDup.open && (
        <HighLightDupList
          data={modalHighlightDup.data}
          modalHighlightDup={modalHighlightDup}
          setModalHighlightDup={setModalHighlightDup}
          path='tab'
          onCreate={(status) => {
            onCreateHighlight();
          }}
        />
      )}
    </>
  );
};

const HistoryFlashSale = ({ flashSaleId }: { flashSaleId: string }) => {
  const [data, setData] = useState<any>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await getFlashSaleHistory(flashSaleId);
        setData(result);
      } catch (error) {
        console.log(error);
      }
    };
    fetchData();
  }, [flashSaleId]);

  const columns = [
    {
      title: "วันเวลาอัปเดท",
      dataIndex: "updateDate",
      key: "updateDate",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{dayjs(value).format("DD/MM/YYYY HH:mm")}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "กิจกรรม",
      dataIndex: "actionLabel",
      key: "actionLabel",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ก่อนแก้ไข",
      dataIndex: "statusBefore",
      key: "statusBefore",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Tag style={{ backgroundColor: mapBgColor[value], border: "none" }}>
                <Text color={mapTextColor[value]} level={6} fontWeight={600}>
                  {mapStatus[value]}
                </Text>
              </Tag>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "หลังแก้ไข",
      dataIndex: "statusAfter",
      key: "statusAfter",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Tag style={{ backgroundColor: mapBgColor[value], border: "none" }}>
                <Text color={mapTextColor[value]} level={6} fontWeight={600}>
                  {mapStatus[value]}
                </Text>
              </Tag>
            </FlexCol>
          ),
        };
      },
    },
    {
      title: "ผู้ใช้งาน",
      dataIndex: "updateBy",
      key: "updateBy",
      render: (value: any, row: any, index: number) => {
        return {
          children: (
            <FlexCol>
              <Text>{value}</Text>
            </FlexCol>
          ),
        };
      },
    },
  ];

  return (
    <>
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#1B4586",
              headerColor: "white",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
              //rowHoverBg: "none",
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={data?.data}
          pagination={false}
          scroll={{ x: "max-content", y: 550 }}
        />
      </ConfigProvider>
    </>
  );
};
